import { useEffect } from 'react';

const SCRIPT_SRC = 'https://js.hsforms.net/forms/v2.js';

const useHubSpotForm = createForm => {
  useEffect(() => {
    const existingScript = !!(window.hbspt && document.querySelector(`script[src="${SCRIPT_SRC}"]`));

    if (!existingScript) {
      const script = document.createElement('script');

      script.src = SCRIPT_SRC;
      script.async = true;
      script.type = 'text/javascript';
      script.onload = createForm;
      document.body.appendChild(script);
    } else {
      createForm();
    }
  }, []);
};

export default useHubSpotForm;
